<template>
  <aside
    :class="[
      'sidebar',
      darkMode ? 'dark' : 'light',
      { collapsed: sidebarColapsada, open: sidebarAberta }
    ]"
  >
    <!-- TOPO -->
    <div class="logo-area">
      <img
        v-if="!sidebarColapsada"
        :src="darkMode ? '/img/logo-brancowebp' : '/img/logo-pretowebp'"
        alt="Click Sorvetes"
        class="logo"
      />

      <button class="btn-toggle" @click="$emit('toggle-collapse')">
        <Menu :size="22" />
      </button>
    </div>

    <!-- LISTA DE SEÇÕES (scroll apenas aqui) -->
    <nav class="nav-scroll">
      <div v-for="(secao, index) in secoes" :key="index" class="menu-section">
        <button class="nav-section" @click="toggleSecao(index)">
          <span class="titulo-secao">{{ secao.secao }}</span>
          <ChevronDown :class="{ aberto: secao.aberta }" :size="18" class="icon-toggle" />
        </button>

        <transition name="fade">
          <div v-show="secao.aberta" class="itens-wrapper">
            <a
              v-for="(item, i) in secao.itens"
              :key="i"
              :href="item.rota"
              class="nav-item"
            >
              <component :is="item.icone" :size="18" />
              <span v-if="!sidebarColapsada">{{ item.nome }}</span>
            </a>
          </div>
        </transition>
      </div>
    </nav>

 
    <!-- Rodapé -->
<!-- Rodapé -->
    <div class="sidebar-footer">
      <!-- Voltar ao início -->
      <button class="btn-backdash" @click="$router.push('/dashboard')">
        <Home :size="18" />
        <span v-if="!sidebarColapsada">Voltar ao Início</span>
      </button>

      <button class="btn-logout" @click="$emit('logout')">
        <LogOut :size="18" />
        <span v-if="!sidebarColapsada">Sair</span>
      </button>

      <button class="btn-backsite" @click="$emit('voltar-site')">
        <ExternalLink :size="18" />
        <span v-if="!sidebarColapsada">Voltar ao site</span>
      </button>
    </div>


  </aside>
</template>

<script>
import {
  Menu, ChevronDown, CreditCard, BarChart2, Image, BookOpen,
  FileText, Calculator, Wrench, GraduationCap, LogOut, ExternalLink, Home
} from "lucide-vue-next";

export default {
  name: "SidebarParceiro",
  components: {
    Menu, ChevronDown, CreditCard, BarChart2, Image, BookOpen,
    FileText, Calculator, Wrench, GraduationCap, LogOut, ExternalLink, Home
  },
  props: {
    sidebarColapsada: Boolean,
    sidebarAberta: Boolean,
    darkMode: Boolean
  },
  data() {
    return { secoes: [] };
  },
  async mounted() {
    try {
      const res = await fetch("/database/menuParceiro.json");
      const data = await res.json();
      this.secoes = data.map(s => ({ ...s, aberta: false }));
    } catch (e) {
      console.error("Erro ao carregar menu:", e);
      this.secoes = [
        {
          secao: "Financeiro",
          aberta: false,
          itens: [
            { nome: "Boletos e Pagamentos", icone: "CreditCard", rota: "#" },
            { nome: "Resumo Financeiro", icone: "BarChart2", rota: "#" }
          ]
        }
      ];
    }
  },
  methods: {
    toggleSecao(i) {
      this.secoes[i].aberta = !this.secoes[i].aberta;
    }
  },
watch: {
  sidebarAberta(novo) {
    // adiciona a classe no body, html e no container principal se existir
    document.body.classList.toggle("menu-aberto", novo);
    document.documentElement.classList.toggle("menu-aberto", novo);

    // tenta travar qualquer container principal que role
    const mainContent = document.querySelector(".dashboard-content, main, #app");
    if (mainContent) {
      mainContent.style.overflow = novo ? "hidden" : "";
      mainContent.style.height = novo ? "100dvh" : "";
    }
  }
}


};
</script>

<style scoped>
/* === BASE === */
.sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: 250px;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  z-index: 100;
  transition: width 0.3s ease, transform 0.3s ease, background 0.2s ease, color 0.2s ease;
  border-right: 1px solid transparent;
}

/* === TEMAS === */
.sidebar.dark {
  background: #0a1a3a;
  color: #f5f6fa;
  border-right-color: rgba(255, 255, 255, 0.08);
}
.sidebar.light {
  background: #ffffff;
  color: #0a1a3a;
  border-right-color: #e5e7eb;
}

/* === COLAPSO E MOBILE === */
.sidebar.collapsed {
  width: 80px;
}
@media (max-width: 1024px) {
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.open {
    transform: translateX(0);
  }
}

/* === TOPO === */
.logo-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  min-height: 64px;
}
.logo {
  height: 34px;
}
.btn-toggle {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
}

/* === SCROLL SEÇÕES === */
.nav-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.25rem 0 1rem;
  scrollbar-width: thin;
}
.nav-scroll::-webkit-scrollbar {
  width: 6px;
}
.nav-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}
.sidebar.dark .nav-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

/* === SEÇÕES === */
.menu-section {
  display: flex;
  flex-direction: column;
}
.nav-section {
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border-radius: 8px;
}
.sidebar.light .nav-section {
  color: #0a1a3a;
}
.sidebar.dark .nav-section {
  color: #f5f6fa;
}
.nav-section:hover {
  background: rgba(0, 0, 0, 0.05);
}
.sidebar.dark .nav-section:hover {
  background: rgba(255, 255, 255, 0.06);
}
.icon-toggle {
  transition: transform 0.25s ease;
}
.icon-toggle.aberto {
  transform: rotate(180deg);
}

/* === ITENS === */
.itens-wrapper {
  display: flex;
  flex-direction: column;
  margin: 0.1rem 0 0.4rem 0.25rem;
}
.nav-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.sidebar.light .nav-item {
  color: #0a1a3a;
}
.sidebar.dark .nav-item {
  color: #f5f6fa;
}
.nav-item:hover {
  background: #ffedf3;
}
.sidebar.dark .nav-item:hover {
  background: #ff5384;
  color: #fff;
}

/* === RODAPÉ === */
.sidebar-footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: inherit;
}
.sidebar.dark .sidebar-footer {
  border-top-color: rgba(255, 255, 255, 0.08);
}
.btn-logout,
.btn-backsite {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  padding: 0.6rem 0.8rem;
  border-radius: 8px;
  width: 100%;
  text-align: left;
}
.btn-logout:hover {
  background: #ff3b63;
  color: #fff;
}
.btn-backsite:hover {
  background: #2563eb;
  color: #fff;
}

/* === TRANSIÇÃO === */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* BLOQUEIA SCROLL DO CONTEÚDO PRINCIPAL */
body.menu-aberto,
html.menu-aberto {
  overflow: hidden !important;
  height: 100dvh !important;
}
.btn-backdash {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.6rem 0.75rem;
  border-radius: 8px;
  width: 100%;
  text-align: left;
  transition: background 0.2s ease;
}

.btn-backdash:hover {
  background: #e5e7eb;
  color: #0a1a3a;
}
.sidebar.dark .btn-backdash:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

</style>
